<p-listbox
  [options]="contextMenus"
  optionLabel="name"
  [(ngModel)]="selectedContextMenu"
  (onChange)="onContextMenuClick()"
></p-listbox>
